import { __ } from '@wordpress/i18n';
import { SimpleInput } from '@getdokan/dokan-ui';

const RuleTitle = ( { rule, setRule, isSubmitting } ) => {
    return (
        <div className="bg-white p-7 rounded-lg shadow mb-5 space-y-5">
            <div className="space-y-2.5">
                <label
                    htmlFor="rule-name"
                    className="block text-sm font-medium text-[#25252D]"
                >
                    { __( 'Quote Rule Title', 'dokan' ) }
                </label>
                <SimpleInput
                    className="p-4"
                    onChange={ ( e ) =>
                        setRule( ( prev ) => ( {
                            ...prev,
                            rule_name: e.target.value,
                        } ) )
                    }
                    input={ {
                        type: 'text',
                        id: 'rule-name',
                        value: rule.rule_name,
                        placeholder: __( 'Title here', 'dokan' ),
                    } }
                    disabled={ isSubmitting }
                />
            </div>
        </div>
    );
};

export default RuleTitle;
